<div [id]="getUniqueID('container')" style="flex: 1 0 auto">
  <div id="main scfont">
    <div style="display: flex; justify-content: center; background-color: white; padding-bottom: 5px">
      <div>
        <img
          src="{{ env.assetsPath }}branding/nassau/Logo.png"
          style="max-width: 100%; height: auto; display: block"
        />
      </div>
    </div>
    <div
      style="padding-top: 5px; padding-bottom: 5px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 6px"
      class="dark-shade"
      >
      <div style="flex: 1 1 0; min-width: 0"></div>
      <div style="text-align: center; flex: 2 1 260px; padding: 0 8px">
        Nassau County Traffic & Parking Violations Agency Online Self Service
      </div>
      <div class="session-timer" style="padding-right: 10px; text-align: right; flex: 1 1 180px; min-width: 140px">
        @if (minutesLeft > 0) {
          <div>Session Remaining: {{ minutesLeft }} min</div>
        }
      </div>
    </div>

    <div
      style="padding-left: 10px; padding-right: 10px; padding-top: 5px; padding-bottom: 10px; overflow-x: hidden; overflow-y: visible">
      <router-outlet></router-outlet>
    </div>
  </div>
  <dx-load-panel
    [visible]="isLoading"
    [container]="getUniqueIDHash('container')"
    [position]="{ of: getUniqueIDHash('container') }"
    [shadingColor]="loading_shadingColor"
  ></dx-load-panel>
</div>
<div
  id="divFooter"
  style="margin-top: 20px; text-align: center; flex-shrink: 0; padding-top: 5px; padding-bottom: 5px"
  class="dark-shade footer"
  >
  <div class="footer-title" style="display: flex; justify-content: center; flex-wrap: wrap">
    <a target="cc3termsofservice" routerLink="/viewdoc" [queryParams]="{ view: 'tos' }">Terms of Service</a>
    <div style="padding-left: 4px; padding-right: 4px">|</div>
    <a target="cc3businesscontact" routerLink="/viewdoc" [queryParams]="{ view: 'bus' }"
      >Business Contact Information</a
      >
      <div style="padding-left: 4px; padding-right: 4px">|</div>
      <a target="cc3refundpolicy" routerLink="/viewdoc" [queryParams]="{ view: 'ref' }">Refund Policy</a>
    </div>
    <div class="footer-copyright">
      A Quest Computer Products solution powered by SureCourt - Copyright © 2012-{{ currentYear }} - Version
      {{ versionNumber() }}
    </div>
  </div>
